<template>
  <div>
    <div class="box online_bg">
      <div class="wrap w1200  onsite_b">
        <!--右侧-->
        <div class="wenjuan_list">
          <dl v-for="(item, i) in examPaperInfo" v-bind:key="item.id">
            <dt v-if="item.questionType !== 'write'">
              <span>{{(i + 1) + '.'}}</span>{{item.questionInfoList.description}}<i>（{{getQType(item.questionType)}}）</i>
            </dt>
            <dt v-if="item.questionType == 'write'">
              <span>{{(i+1) + '.'}}</span>
              <a>{{item.infoAnswer}}</a>
              <i>（{{getQType(item.questionType)}}）</i>
            </dt>
            <dd v-if="item.questionType == 'selection'">
              <p class="font14 colorBlack mb25 displayFlex" v-for="i in item.answerInfoList" :key="i.id">
                <input type="radio" :name="item.questionInfoList.description" :value="i.no" disabled v-model="item.infoAnswer" />
                <span class="marginSpan">{{String.fromCharCode(65 + parseInt(i.no))}}.</span> {{i.description}}
              </p>
            </dd>
            <dd v-if="item.questionType == 'multiSelection'">
              <p class="font14 colorBlack mb25 displayFlex" v-for="i in item.answerInfoList" :key="i.id">
                <input type="checkbox" style="opacity: 1" :name="item.questionInfoList.description" :value="i.no" disabled :checked="ifchecked(i.no, item.infoAnswer)"/>
                <span class="marginSpan">{{String.fromCharCode(65 + parseInt(i.no))}}.</span> {{i.description}}
              </p>
            </dd>
            <dd v-if="item.questionType == 'judgement'">
              <p class="font14 colorBlack mb25 displayFlex" v-for="i in item.answerInfoList" :key="i.id">
                <input type="radio" :name="item.questionInfoList.description" :value="i.no" disabled v-model="item.infoAnswer"/>
                <span class="marginSpan">{{String.fromCharCode(65 + parseInt(i.no))}}.</span> {{i.description}}
              </p>
            </dd>
            <dd v-if="item.questionType == 'short'">
              <textarea class="text_con" placeholder="请输入您的回答" disabled v-model="item.infoAnswer"></textarea>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      data () {
        return {
          examId: this.$route.params.id,
          examPaperInfo: {}
        }
      },
      created () {
        this.getExamPaper(this.examId)
      },
      methods: {
        getQType (type) {
          switch (type) {
            case 'write': {
              return '填空';
            }
            case 'selection': {
              return '单选';
            }
            case 'multiSelection': {
              return '多选';
            }
            case 'judgement': {
              return '判断'
            }
            case 'short': {
              return '简答'
            }
          }
        },
        getExamPaper (examId) {
          this.$api.post(this.$global.examApiPath, '/examQuestion/getListByExam', {examId: examId}, r => {
            if (r.data) {
              this.examPaperInfo = r.data
            }
          })
        },
        ifchecked (id, answer) {
          let answerList = answer.split('')
          for (let i = 0; i < answerList.length; i++) {
            let o = answerList[i]
            if (id == o) {
              return true
            }
          }
          return false
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/modules/questionnaire/result.vue